import script from "./AdStats.vue?vue&type=script&setup=true&lang=js"
export * from "./AdStats.vue?vue&type=script&setup=true&lang=js"

import "./AdStats.vue?vue&type=style&index=0&id=d3f87612&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3f87612"]])

export default __exports__